<template>
  <div>
      <div v-if="loadingNota" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
          <img src="/public/img/loading-bar.gif" />
      </div>
      <div class="container-notas" v-else>

        <div v-if="nota.turma && !mostraTabNotas && !mostraTabParecer" class="u-mt-20" style="text-align:center; color:#909399; padding:40px;">
          A consulta de notas não está habilitada para o seu perfil.
        </div>
        <div v-else class="u-mt-20">
          <el-tabs type="border-card" v-model="tabAtivo">

              <el-tab-pane v-if="mostraTabNotas" name="notas" :label="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo' ? 'NOTAS' : 'PARECER'">

                  <template v-if="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo'">
                      <div class="u-text-right u-mb-5" style="margin-right: 6px;" v-if="$store.state.user.tipo == 6">
                          <el-button @click="openGerenciarCalcMedia()" type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                      </div>
                      <el-row :gutter="10" v-if="nota && nota.turma">
                          <el-col :xs="24" :sm="24" :md="24">

                              <div class="container-table" v-for="(periodo, i) in nota.turma.periodos_diario" :key="i" style="margin: 0 5px; overflow-x: auto !important;">
                                  <table class="table table-striped table-nota">
                                      <thead>
                                          <tr class="linha-nota">
                                              <th class="u-text-center" :colspan="defineQtdAtividades[i+1] + 3">{{ periodo }}</th>
                                          </tr>
                                          <tr>
                                              <th class="u-text-left" style="width: 140px; padding-left: 9px !important;">
                                                Disciplinas
                                              </th>
                                              <th v-for="(atividades, k) in defineQtdAtividades[i+1]" :key="`d${i+k}`" class="vertical-text">
                                                  Atividade {{ String(k+1).padStart(2, '0') }}
                                              </th>
                                              <th class="vertical-text">Média</th>
                                              <th class="vertical-text">Recuperação</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr v-for="(disc, j) in nota.atividades" :key="`n${i+j}`" class="linha-nota">
                                              <td class="u-text-left u-pointer">
                                                <span class="td-nome-disciplina">{{ nota['disciplinas'][j] }}</span>
                                              </td>
                                              <template v-for="(item, y) in disc[i+1]" >
                                                  <td v-if="y != 'm' && y != 'r'" :key="`i${i+j+y}`" class="u-text-center u-pointer">
                                                      
                                                      
                                                      <span v-if="$store.state.user.id == nota.atividades[j][i+1][y]['u']" style="font-weight: bold; color: #00aaff;">
                                                          {{ nota.atividades[j][i+1][y]['v'] }}
                                                      </span>
                                                      <span v-else>
                                                          {{ nota.atividades[j][i+1][y]['v'] }}
                                                      </span>
                                                                                                                  
                                                  </td>
                                              </template>
                                              <td v-for="(item, m) in defineQtdAtividades[i+1] - (Object.keys(disc[i+1]).length - 2)" :key="`v${i+j+m}`" class="u-text-center"></td>
                                              <td class="u-text-center">{{ nota.atividades[j][i+1]['m']['v'] }}</td>
                                              <td class="u-text-center">
                                                  {{ nota.atividades[j][i+1]['r']['v'] }}
                                              </td>
                                          </tr>
                                              
                                      </tbody>
                                  </table>
                              </div>

                          </el-col>
                      </el-row>
                      
                      <el-row class="u-mt-20" :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24">
                              <table class="table table-striped table-nota">
                                  <thead>
                                      <tr class="linha-nota">
                                          <th class="u-text-center" colspan="11">MÉDIA PARCIAL</th>
                                      </tr>
                                      <tr class="linha-nota">
                                          <th><span class="td-nome-disciplina">Disciplina</span></th>
                                          <th class="u-text-center">Nota</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr class="linha-nota" v-for="(item, j) in nota.atividades" :key="j">
                                          <td>
                                            <span class="td-nome-disciplina">{{ nota['disciplinas'][j] }}</span>
                                          </td>
                                          <td class="u-text-center">{{ item['m_parcial'] && (item['m_parcial']['v'] || item['m_parcial']['v'] === 0) ? item['m_parcial']['v'] : 'SN' }}</td>
                                      </tr>            
                                  </tbody>
                              </table>
                          </el-col>
                      </el-row>

                      <el-row class="u-mt-20" :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24">
                              <table class="table table-striped table-nota">
                                  <thead>
                                      <tr class="linha-nota">
                                          <th class="u-text-center" colspan="11">RECUPERAÇÃO FINAL</th>
                                      </tr>
                                      <tr class="linha-nota">
                                          <th><span class="td-nome-disciplina">Disciplina</span></th>
                                          <th class="u-text-center">Nota</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr class="linha-nota" v-for="(item, j) in nota.atividades">
                                          <td>
                                            <span class="td-nome-disciplina">{{ nota['disciplinas'][j] }}</span>
                                          </td>
                                          <td :key="j" class="u-text-center u-pointer">

                                              <span v-if="$store.state.user.id == item['r']['u']" style="font-weight: bold; color: #00aaff;">
                                                  {{ (item['r'] && item['r']['v'] ? item['r']['v'] : '') }}
                                              </span>
                                              <span v-else>
                                                  {{ (item['r'] && item['r']['v'] ? item['r']['v'] : '') }}
                                              </span>
                                              
                                              
                                          </td>
                                      </tr>            
                                  </tbody>
                              </table>                            
                          </el-col>
                      </el-row>

                      <el-row class="u-mt-20" :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24">
                              <table class="table table-striped table-nota">
                                  <thead>
                                      <tr class="linha-nota">
                                          <th class="u-text-center" colspan="11">MÉDIA FINAL</th>
                                      </tr>
                                      <tr class="linha-nota">
                                          <th><span class="td-nome-disciplina">Disciplina</span></th>
                                          <th class="u-text-center">Nota</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr class="linha-nota" v-for="(item, j) in nota.atividades" :key="j">
                                          <td>
                                            <span class="td-nome-disciplina">{{ nota['disciplinas'][j] }}</span>
                                          </td>
                                          <td class="u-text-center">{{ item['m_final'] && item['m_final']['v'] ? item['m_final']['v'] : '' }}</td>
                                      </tr>            
                                  </tbody>
                              </table>
                          </el-col>
                      </el-row>

                  </template>

                  <template v-else-if="nota.turma">

                      <fieldset v-for="(periodo, i) in nota.turma.periodos_diario" :key="i" class="fieldset-nota">
                          <legend>PARECER {{ periodo }}</legend>
                          {{ nota.parecer[i + 1] }}
                      </fieldset>

                  </template>

              </el-tab-pane>

              <el-tab-pane v-if="mostraTabConceito" name="conceito" label="CONCEITOS">

                  <el-row :gutter="10" v-if="nota.conceito">
                      <el-col :xs="24" :sm="24" :md="24">

                          <!-- Conceitos por período: disciplinas × atividades + conceito do período -->
                          <div class="container-table" v-for="(periodo, i) in nota.conceito.periodos" :key="`cp${i}`" style="margin: 0 5px; overflow-x: auto !important;">
                              <table class="table table-striped table-nota">
                                  <thead>
                                      <tr class="linha-nota">
                                          <th class="u-text-center" :colspan="maxAvaliacoes(i+1) + 2">{{ periodo }}</th>
                                      </tr>
                                      <tr>
                                          <th class="u-text-left" style="width: 140px; padding-left: 9px !important;">Disciplinas</th>
                                          <th v-for="k in maxAvaliacoes(i+1)" :key="`ah${i}-${k}`" class="vertical-text">Atividade {{ String(k).padStart(2, '0') }}</th>
                                          <th class="vertical-text">Conceito final</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for="d in nota.conceito.geral" :key="`cr${i}-${d.disciplina_id}`" class="linha-nota">
                                          <td class="u-text-left"><span class="td-nome-disciplina">{{ d.disciplina }}</span></td>
                                          <td v-for="k in maxAvaliacoes(i+1)" :key="`ac${i}-${d.disciplina_id}-${k}`" class="u-text-center">
                                              {{ avaliacaoConceito(d, i+1, k-1) }}
                                          </td>
                                          <td class="u-text-center"><b>{{ escalaLabel(d.conceitos[i+1]) }}</b></td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>

                          <!-- Resultado final: recuperação + conceito final do ano -->
                          <div class="container-table" v-if="nota.conceito.tem_recuperacao || nota.conceito.tem_final" style="margin: 10px 5px; overflow-x: auto !important;">
                              <table class="table table-striped table-nota">
                                  <thead>
                                      <tr class="linha-nota">
                                          <th class="u-text-center" :colspan="1 + (nota.conceito.tem_recuperacao ? 1 : 0) + (nota.conceito.tem_final ? 1 : 0)">RESULTADO FINAL</th>
                                      </tr>
                                      <tr>
                                          <th class="u-text-left" style="width: 140px; padding-left: 9px !important;">Disciplinas</th>
                                          <th v-if="nota.conceito.tem_recuperacao" class="u-text-center">Recuperação</th>
                                          <th v-if="nota.conceito.tem_final" class="u-text-center">Conceito final</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for="d in nota.conceito.geral" :key="`cf${d.disciplina_id}`" class="linha-nota">
                                          <td class="u-text-left"><span class="td-nome-disciplina">{{ d.disciplina }}</span></td>
                                          <td v-if="nota.conceito.tem_recuperacao" class="u-text-center">{{ escalaLabel(d.conceitos['r']) }}</td>
                                          <td v-if="nota.conceito.tem_final" class="u-text-center"><b>{{ escalaLabel(d.conceitos['m_final']) }}</b></td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div>

                      </el-col>
                  </el-row>

              </el-tab-pane>

              <el-tab-pane v-if="mostraTabParecer" name="parecer" :label="nota.turma && nota.turma.metodo_avaliacao == 'quantitativo' ? 'PARECER' : 'PARECER FINAL'">

                  <template v-if="nota && nota.notas_parecer && nota.notas_parecer.parecer">
                      <el-row :gutter="10" v-for="(item, i) in nota.notas_parecer.parecer" :key="i">
                          <el-col :xs="24" :sm="24" :md="24">

                              <div style="border: 1px solid #a9a9a9; border-radius: 12px; padding: 30px; margin-top: 20px;">
                                  <div style="font-size: 17px;">Parecer / Observação - {{ i }}º Trimestre</div>
                                  <div v-if="item">                                    
                                      <hr class="u-mt-30">{{ item }}</hr>
                                  </div>
                                  <div v-else>
                                      <hr class="u-mt-30" />
                                      <hr class="u-mt-30" />
                                      <hr class="u-mt-30" />
                                      <hr class="u-mt-30" />
                                  </div>
                              </div>

                          </el-col>
                      </el-row>
                  </template>

                  <el-row :gutter="10">
                      <el-col :xs="24" :sm="24" :md="24">

                          <div style="border: 1px solid #a9a9a9; border-radius: 12px; padding: 30px; margin-top: 20px;">
                              <span style="font-size: 17px;">Resultados finais</span>
                              <div v-if="nota.conselho_parcial">                                    
                                  <hr class="u-mt-30"><span v-if="nota.parecer_final">{{ nota.parecer_final }}<br/></br></span>{{ nota.conselho_parcial['observacao'] }}</hr>
                              </div>
                              <div v-else-if="nota.conselho_final">                                    
                                  <hr class="u-mt-30"><span v-if="nota.parecer_final">{{ nota.parecer_final }}<br/></br></span>{{ nota.parecer_final }} {{ nota.conselho_final['observacao'] }}</hr>
                              </div>
                              <div v-else>
                                  <hr class="u-mt-30" />
                                  <hr class="u-mt-30" />
                                  <hr class="u-mt-30" />
                                  <hr class="u-mt-30" />
                              </div>
                          </div>

                      </el-col>
                  </el-row>

              </el-tab-pane>

              <!-- BLOCO N — item 14: desempenho em gráfico. Os valores vêm do backend
                   (mesmo payload das notas); o Vue apenas adapta o formato. -->
              <el-tab-pane v-if="mostraTabNotas" name="desempenho" label="DESEMPENHO">
                  <div style="padding: 10px 5px;">
                      <div v-if="!temSerieDesempenho" class="u-text-center" style="color:#909399; padding:24px;">
                          Ainda não há médias lançadas para montar o gráfico.
                      </div>
                      <div v-else>
                          <grafico-svg
                              tipo="linha"
                              titulo="Evolução das médias por período"
                              :rotulos="rotulosPeriodos"
                              :series="seriesDesempenho"
                              mensagem-vazio="Ainda não há médias lançadas." />
                          <p style="color:#909399; font-size:12px; margin-top:8px;">
                              Cada linha é um componente curricular. Períodos sem média lançada
                              ficam como lacuna — ausência de nota não é zero.
                          </p>
                      </div>
                  </div>
              </el-tab-pane>

              <el-tab-pane name="faltas" label="FALTAS">
                  <div v-loading="loadingFaltas" style="padding: 10px 5px;">
                      <div v-if="faltas">
                          <div style="display:flex; align-items:center; gap:14px; border:1px solid #ebeef5; border-radius:8px; padding:14px 18px; margin-bottom:16px;">
                              <div style="font-size:34px; font-weight:bold; color:#e6a23c; line-height:1;">{{ faltas.total_faltas }}</div>
                              <div style="color:#606266;">Total de faltas<span v-if="faltas.turma_nome"> — Turma {{ faltas.turma_nome }}</span></div>
                          </div>

                          <div v-if="faltas.sem_lancamento" class="u-text-center" style="color:#909399; padding:20px;">
                              Ainda não há frequência lançada para você nesta turma.
                          </div>

                          <table v-else-if="faltas.por_disciplina && faltas.por_disciplina.length" class="table table-striped">
                              <thead>
                                  <tr>
                                      <th>Disciplina</th>
                                      <th class="u-text-center" style="width:120px;">Faltas</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(d, i) in faltas.por_disciplina" :key="i">
                                      <td>{{ d.disciplina }}</td>
                                      <td class="u-text-center">{{ d.faltas }}</td>
                                  </tr>
                              </tbody>
                          </table>

                          <div v-else class="u-text-center" style="color:#909399; padding:20px;">
                              Sem faltas por disciplina para exibir.
                          </div>

                          <p style="color:#909399; font-size:12px; margin-top:10px;">O total já considera as faltas reconsideradas (abonadas), quando houver.</p>
                      </div>
                  </div>
              </el-tab-pane>

          </el-tabs>

          <!-- BLOCO N — item 16: impressão do boletim. O PDF é montado pelo backend a
               partir de NotaService::printBoletimEscola; nada é recalculado aqui. -->
          <div class="u-text-right" style="padding: 10px 12px;">
              <el-button size="mini" type="primary" icon="el-icon-printer"
                         :loading="baixandoBoletim" @click="imprimirBoletim">
                  IMPRIMIR BOLETIM
              </el-button>
          </div>
        </div>

      </div>



  </div>
</template>
<script>

import GraficoSvg from '@/shared/grafico/grafico-svg.vue'

export default {
  components: { GraficoSvg },
  data: () => ({
      dialogGerenciarCalcMedia: false,
      alunoSelected: {},
      defineQtdAtividades: {},
      loadingObservacoes: false,
      tabAtivo: 'notas',
      nota: {},
      loadingNota: true,
      dialogChangeNota: false,
      observacoes: [],
      paginateObservacoes: {
          page: 1,
          qtdItens: null,
          from: '',
          to: ''
      },
      changeNota: {
          aluno_id: '',
          turma_id: '',
          disciplina: '',
          periodo: '',
          nota: ''
      },
      calcNota: {
          qtd_dvisao: ''
      },
      faltas: null,
      loadingFaltas: false,
      baixandoBoletim: false
  }),
  mounted () {

      this.getNota();
      this.getFaltas();
  },
  computed: {
    /*
     * BLOCO N — item 14. Adapta o payload de notas (JÁ calculado pelo backend) para o
     * formato do gráfico. Nenhuma média é calculada aqui: valor ausente vira `null` e o
     * gráfico deixa a lacuna, em vez de plotar zero.
     */
    /**
     * `turma.periodos_diario` é um ARRAY de rótulos — ['1º Trimestre', '2º Trimestre', …] —
     * e não a quantidade. `Number([...])` dava NaN, o laço `i <= NaN` nunca rodava e a lista
     * saía vazia; com ela, o gráfico de desempenho não tinha eixo nenhum.
     *
     * Usa os rótulos que a turma define (trimestre, bimestre…) em vez de inventar "1º, 2º".
     */
    rotulosPeriodos () {
        const p = (this.nota && this.nota.turma) ? this.nota.turma.periodos_diario : null
        if (Array.isArray(p) && p.length) return p.slice()

        const qtd = Number(p) > 0 ? Number(p) : 4
        const r = []
        for (let i = 1; i <= qtd; i++) r.push(i + 'º')
        return r
    },
    /**
     * Média de cada componente por período, para o gráfico da aba DESEMPENHO.
     *
     * O payload NÃO tem uma lista de disciplinas com `periodos`/`media`, que é o que este
     * método presumia (`disciplinas.forEach` lançava "forEach is not a function" e derrubava
     * o render inteiro do Diário — a tela ficava só com as abas, sem conteúdo nenhum).
     *
     * O formato real:
     *   nota.disciplinas   -> { "33": "MATEMÁTICA", ... }        mapa id → nome
     *   nota.atividades    -> { "33": { "1": { m: {v: "3,1"} }, "2": {...}, m_parcial, m_final } }
     *
     * A média do período está em `[disciplinaId][periodo].m.v`, em texto e com VÍRGULA
     * decimal — daí a troca por ponto antes do Number.
     */
    seriesDesempenho () {
        const atividades = (this.nota && this.nota.atividades) ? this.nota.atividades : {}
        const nomes = (this.nota && this.nota.disciplinas) ? this.nota.disciplinas : {}
        const qtd = this.rotulosPeriodos.length
        const series = []

        Object.keys(atividades).forEach(id => {
            const porPeriodo = atividades[id] || {}
            const valores = []

            for (let i = 1; i <= qtd; i++) {
                const p = porPeriodo[i]
                const bruto = (p && p.m && p.m.v !== undefined && p.m.v !== null && p.m.v !== '')
                    ? Number(String(p.m.v).replace(',', '.')) : null
                valores.push((bruto === null || isNaN(bruto)) ? null : bruto)
            }

            if (valores.some(v => v !== null)) {
                series.push({ nome: nomes[id] || ('Componente ' + id), valores: valores })
            }
        })

        return series
    },
    temSerieDesempenho () { return this.seriesDesempenho.length > 0 },
      permissoes () { return this.$store.getters.permissoes },
      ehQuantitativo () { return !!(this.nota && this.nota.turma && this.nota.turma.metodo_avaliacao == 'quantitativo') },
      // Turma opera por conceito (método global conceito; turma não qualitativa).
      usaConceito () { return !!(this.nota && this.nota.usa_conceito) },
      // Aba de notas (tab 1): quando conceito, a tabela numérica é ocultada.
      mostraTabNotas () { return !this.usaConceito && (this.ehQuantitativo ? this.permissoes.ver_notas : this.permissoes.ver_parecer) },
      // Aba de conceitos: só quando o método é conceito e o aluno pode ver notas.
      mostraTabConceito () { return this.usaConceito && this.permissoes.ver_notas },
      // Aba de parecer (tab 2): sempre parecer, exige ver_parecer.
      mostraTabParecer () { return this.permissoes.ver_parecer }
  },
  methods: {
    /**
     * Item 16 — baixa o PDF pela rota autenticada. Aluno e turma são resolvidos pelo
     * TOKEN no backend: nenhum id é enviado daqui.
     */
    imprimirBoletim () {
        this.baixandoBoletim = true

        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/boletim/imprimir`, {},
            Object.assign({}, this.$store.getters.getHeaderAuth, { responseType: 'blob' })
        ).then(r => {
            this.baixandoBoletim = false

            const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
            const a = document.createElement('a')
            a.href = url
            a.download = 'boletim.pdf'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)

        }).catch(e => {
            this.baixandoBoletim = false

            const st = (e && e.response) ? e.response.status : null
            const msg = st === 403 ? 'Boletim não disponível para esta matrícula.'
                : st === 401 ? 'Sessão expirada. Entre novamente.'
                : 'Não foi possível gerar o boletim.'

            window.eventBus.$emit('alert', { msg: msg, type: 'warning' })
        })
    },
      escalaLabel (v) {
          if (v === null || v === undefined || v === '') return '';
          const escala = (this.nota.conceito && this.nota.conceito.escala) || [];
          const it = escala.find(e => String(e.v) === String(v));
          return it ? it.l : v;
      },
      // Maior quantidade de avaliações (atividades) entre as disciplinas no período (modo múltiplo).
      maxAvaliacoes (periodo) {
          const geral = (this.nota.conceito && this.nota.conceito.geral) || [];
          let max = 0;
          geral.forEach(d => {
              const avs = (d.avaliacoes && d.avaliacoes[periodo]) ? d.avaliacoes[periodo].length : 0;
              if (avs > max) max = avs;
          });
          return max;
      },
      avaliacaoConceito (d, periodo, index) {
          const avs = (d.avaliacoes && d.avaliacoes[periodo]) ? d.avaliacoes[periodo] : [];
          return avs[index] ? this.escalaLabel(avs[index].conceito) : '';
      },

      openGerenciarCalcMedia(){

          this.loading = true;

          this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getCalcNotaQtdDvisao/${this.aluno_id}/${this.turma_id}`, this.$store.getters.getHeaderAuth).then(response => {

              if(response.data.calc_nota_qtd_dvisao > 0) {
                  
                  this.calcNota.qtd_dvisao = response.data.calc_nota_qtd_dvisao;
              }

              this.dialogGerenciarCalcMedia = true;
              
              this.loading = false;
              
          }).catch((error) => { this.$store.commit('throwException', error); window.eventBus.$emit('loading', false); });
          
      },
      onSubmitGerenciarCalcMedia() {

          this.$refs.calcNota.validate((valid) =>{ if(valid){

              this.$msgbox.confirm(`Tem certeza que deseja alterar a fórmula de cálculo da média deste aluno?`, 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                  window.eventBus.$emit('loading', true);

                  let payload = {
                      aluno_id: this.aluno_id,
                      turma_id: this.turma_id,
                      qtd_dvisao: this.calcNota.qtd_dvisao
                  };

                  this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeCalcNotaQtdDvisao`, payload, this.$store.getters.getHeaderAuth).then(response => {
                                              
                      if(typeof response.data.erro !== 'undefined'){

                          this.$alert(response.data.erro, 'Atenção', {
                              confirmButtonText: 'OK',
                              type: 'warning'
                          }).catch(()=>{});

                      }else{
                          
                          window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                          this.dialogGerenciarCalcMedia = false;
                      }

                      window.eventBus.$emit('loading', false);

                  }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

              }).catch(()=>{});

          }else{
              window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
          }});
      }, 
    
      getFaltas(){

          this.loadingFaltas = true;
          // aluno_id/turma_id são resolvidos no backend pelo token (middleware portal-aluno).
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/faltas`, {}, this.$store.getters.getHeaderAuth).then(response => {

              this.loadingFaltas = false;
              if(response.data && typeof response.data.erro !== 'undefined'){
                  window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                  return;
              }
              this.faltas = response.data;

          }).catch(error => { this.loadingFaltas = false; this.$store.commit('throwException', error); });
      },
      getNota(){

        this.loadingNota = false;

        let payload = {};

        payload['turma_id'] = this.$store.state.user.turma_id;
        payload['aluno_id'] = this.$store.state.user.aluno_id;

        console.log(this.$store.getters.getHeaderAuth);
          
          this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/portal/get-nota-for-portal-aluno`, payload, this.$store.getters.getHeaderAuth).then(response => {

              if(typeof response.data.error !== 'undefined' || typeof response.data.erro !== 'undefined'){

                  window.eventBus.$emit('alert', {msg: response.data.error || response.data.erro, type: 'warning'});
                  this.nota = {};
                  this.$emit('close');

              }else{

                  // Sincroniza as permissões vindas na resposta (consistentes com o que o
                  // backend filtrou) antes de renderizar — evita exibir tab de notas vazia.
                  if(response.data.permissoes) {
                      this.$store.commit('setPermissoes', response.data.permissoes);
                  }

                  this.nota = response.data;

                  // Método por conceito: abre direto na aba CONCEITOS.
                  if(this.usaConceito && this.mostraTabConceito) {
                      this.tabAtivo = 'conceito';
                  } else if(!this.mostraTabNotas && this.mostraTabParecer) {
                      // Se a aba de notas está oculta por permissão, ativa a de parecer.
                      this.tabAtivo = 'parecer';
                  }

                  if(this.nota.turma.metodo_avaliacao == 'quantitativo') {
                      
                      for(let i in this.nota.atividades) {
                          let atividade = this.nota.atividades[i];
                          Object.entries(atividade).forEach(([k2, val]) => {
                              if (this.defineQtdAtividades[k2] && this.defineQtdAtividades[k2] > (Object.keys(val).length - 2)) {
                                  return;
                              }
                              this.defineQtdAtividades[k2] = Object.keys(val).length < 8 ? 6: Object.keys(val).length - 2;
                          });
                      }
                  }

                  this.loadingNota = false;

              } 

          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
      },     
      close(){
          this.$emit('close');
      },
      getPagePagination(page){
        this.paginateObservacoes.page = page;
      },
      formatarTexto(texto) {

          if(texto == '' || texto == null) {
              return texto;
          }

          texto = texto.toLowerCase();

          const partes = texto.split(" ");

          partes[0] = partes[0].charAt(0).toUpperCase() + partes[0].slice(1);

          return partes.join(" ");
      }
  }
  // O `components: { GraficoSvg }` fica no topo do objeto. Havia um segundo
  // `components: {}` vazio aqui embaixo: chave repetida em objeto JS, a última vence,
  // e o registro do gráfico era descartado — <grafico-svg> virava elemento desconhecido
  // e a aba DESEMPENHO não desenhava nada.
}
</script>
<style>
  .container-notas {
    font-size: 13px !important;
  }
  .table-nota td, .table-nota th {
      border: 1px solid #ccc !important;
  }
  .vertical-text {
      writing-mode: vertical-rl;
      transform: rotate(180deg);
      padding: 10px;
      height: 95px;
      text-align: center;
      width: 20px !important;
  }
  .input-nota .el-input__inner {
      border: none !important;
      background-color: #efefef;
      text-align: center;
  }

  .table-nota.table th, .table-nota.table td {
      padding: 0px;
      vertical-align: middle;
  }

  .linha-nota th, .linha-nota td {
      height: 25px !important;
  }

  .fieldset-nota{
      min-height: 150px;
      text-transform: uppercase;
      padding: 10px;
      border-radius: 10px;
      margin: 20px 0;
  }

  .td-nome-disciplina {
    padding-left: 10px;
  }

  @media (max-width: 575px) {

    .td-nome-disciplina {
      padding-left: initial;
    }

    .table td, .table th {
      padding: 0 10px !important;
    }

    .container-table {
      overflow-x: auto !important;
    }
  }
</style>